import React from "react";

import { Box, Heading } from "@blasterjs/core";

import { CaseWithImages, ImageAndQuery } from "../models";
import { useAppDispatch } from "../hooks";
import { LoggedInUser, RolePermissions } from "../permissions";
import { toggleSidebarExpanded } from "../slices/caseImageViewer";
import { CollapseIcon } from "./Expandable";
import UnifiedAnnotationTree from "./UnifiedAnnotationTree";
import SidebarPanelCaseDetails from "./SidebarPanelCaseDetails";

interface Props {
  readonly studyName: string | null;
  readonly selectedImage: ImageAndQuery | null;
  readonly histoCase: CaseWithImages | null;
  readonly userCanDeleteAnnotations: boolean;
  readonly loggedInUser: LoggedInUser;
}

const SidebarPanelAnnotations = ({
  studyName,
  selectedImage,
  histoCase,
  userCanDeleteAnnotations,
  loggedInUser
}: Props) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <Box display="flex" width="100%" mb={2}>
        <Box textAlign="left">
          <Heading as="h5">Annotations</Heading>
        </Box>
        <Box ml={"auto"}>
          <CollapseIcon onToggle={() => dispatch(toggleSidebarExpanded())} />
        </Box>
      </Box>

      <SidebarPanelCaseDetails
        loggedInUser={loggedInUser}
        histoCase={histoCase}
        selectedImage={selectedImage}
        studyName={studyName}
      />
      <hr />

      {selectedImage !== null &&
        loggedInUser.can([RolePermissions.AP_ImageCaseViewer_ViewAnnotationstab]) && (
          <UnifiedAnnotationTree
            userCanDeleteAnnotations={userCanDeleteAnnotations}
            imageId={selectedImage.image.id}
            caseStatus={histoCase ? histoCase.caseWithStatus.status : null}
            loggedInUser={loggedInUser}
          />
        )}
    </>
  );
};

export default SidebarPanelAnnotations;
